module.exports = __webpack_public_path__ + "static/Zusammengefasste Auswertung der Online-Beteiligung-15e8beab8035f783c0f43fc26f63e1ef.pdf";